//Dependencies
import React from 'react'
import { useLocation } from "react-router";

//Components
import CoursesContent from '../content/CoursesContent';
import AccountContent from '../content/AccountContent';
import HelpContent from '../content/HelpContent';
import AddNewCourseContent from '../content/AddNewCourseContent';
import UsersContent from '../content/UsersContent';

const ContentContainer = () => {
    var urlLocation = useLocation()

    const renderPath = () => {
        switch (urlLocation.pathname) {
            case "/dashboard/courses":
                return <CoursesContent />;
            case "/dashboard/account":
                return <AccountContent />;
            case "/dashboard/help":
                return <HelpContent />;
            case "/dashboard/add-new-course":
                return <AddNewCourseContent />;
            case "/dashboard/users":
                return <UsersContent />;
            default:
                return <h1>Error! URL not found</h1>;
        }
    };
    return (
        <div className='px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 py-5 w-full h-auto flex flex-col items-center bg-[#FCFCFC] overflow-x-hidden' id='contentContainer'>
            {renderPath()}
        </div>
    )
}

export default ContentContainer